import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Ensure consistent scaling without breaking the layout
const ensureConsistentScaling = () => {
  // Only apply minimal fixes that don't break the layout
  // Note: visualViewport.scale is read-only, so we don't try to set it
  
  // Set basic font size without forcing transforms
  document.documentElement.style.fontSize = '12.6px';
  document.documentElement.style.webkitTextSizeAdjust = '100%';
  document.documentElement.style.msTextSizeAdjust = '100%';
};

// Apply minimal scaling fix on load
window.addEventListener('load', ensureConsistentScaling);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 